import { DestinationStandardMapping } from "../types";

const twitterStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [],
};

// TODO: Hit Twitter API and get customer's campaigns
export const getTwitterStandardMapping = async () => {
  return twitterStandardMapping;
};
